import { AppDispatch } from "@Reducers/index";
import { getBackendUrl } from "@Utils";
import axiosWrapper from "../services/axiosWrapper";
import { setWorkflowData, setReviewData } from "../reducers/Workflows";
import type { GetWorkflowDataRequest, GetWorkflowDataResponse } from "@ServerTypes/workflows/workflows.schema.js";
import type { GetReviewDataRequest, GetReviewDataResponse } from "@ServerTypes/reviews/reviews.schema.js";

export function fetchWorkflowData({ workflowId }: { workflowId: string }) {
  return async (dispatch: AppDispatch) => {
    const data: GetWorkflowDataRequest = { id: workflowId };
    const response = await axiosWrapper.post<GetWorkflowDataResponse>(
      `${getBackendUrl()}/workflows/getWorkflowData`,
      data,
    );

    if (response.data.status && response.data.result) {
      dispatch(setWorkflowData(response.data.result));
    }
  };
}

export function fetchReviewData({ reviewId }: { reviewId: string }) {
  return async (dispatch: AppDispatch) => {
    const data: GetReviewDataRequest = { _id: reviewId };

    const response = await axiosWrapper.post<GetReviewDataResponse>(`${getBackendUrl()}/reviews/getReviewData`, data);

    if (response.data.status && response.data.result) {
      dispatch(setReviewData(response.data.result));
    }
  };
}
